module.exports = __webpack_public_path__ + "static/ngpm-cut-6e1586f719e06ed340b64de3645152b6.webm";